const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("iFrame", "uipress-pro"),
  moduleName: "uip-iframe",
  description: __("Outputs a iframe block", "uipress-pro"),
  category: __("Dynamic", "uipress-pro"),
  group: "elements",
  icon: "public",
};
